import React, { useRef } from 'react';
import Nabvar from '../Components/Navbar/Navbar'
import { Outlet } from 'react-router-dom';
import { useMediaQuery } from '@react-hook/media-query';
import Footer from '../Components/Footer/Footer'
import BtnWhatsapp from '../Components/BtnWhatsapp/BtnWhatsapp'
import Cart from '../Components/Cart/Cart'
import MobileNav from '../Components/MobileNav/MobileNav'
export default function IndexLayout() {
    const cartRef = useRef(null);

    const handleCartOpen = () => {
        if (cartRef.current && cartRef.current.openCart) {
            cartRef.current.openCart();
        }
    };

    const isScreenLarge = useMediaQuery('(min-width: 900px)');
    return (
        <div className='main-wrapper'>
            {isScreenLarge ?
                <>
                    <Nabvar />
                    <Outlet />
                    <Footer />
                    <BtnWhatsapp />
                    <Cart ref={cartRef} />
                </> :
                <>
                    <Outlet />
                    <Footer />
                    <Cart ref={cartRef} />
                    <MobileNav onCartOpen={handleCartOpen} />
                </>}

            <div className='espaciobg2'>

            </div>

        </div>
    );
}
